import { useNavigate } from 'react-router-dom';
import { Star, MapPin } from 'lucide-react';
import type { Place } from '@wingman/shared';

interface PlaceCardProps {
  place: Place;
  onClick?: (place: Place) => void;
}

export default function PlaceCard({ place, onClick }: PlaceCardProps) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) onClick(place);
    else navigate(`/place/${place.id}`);
  };

  return (
    <button type="button" className="place-card block w-full text-left" onClick={handleClick} style={place.categoryName ? { ['--card-accent' as string]: `var(--category-${place.categoryName})` } : undefined}>
      <div className="flex items-start justify-between gap-2">
        <div className="flex min-w-0 flex-1 items-start gap-3">
          <span className="mt-1 h-2.5 w-2.5 shrink-0 rounded-full bg-brand-500 ring-4 ring-brand-500/10" aria-hidden="true" />
          <div className="min-w-0">
            <h3 className="truncate font-semibold text-gray-900 dark:text-gray-100">{place.name}</h3>
            {place.categoryName && (
              <span className="text-xs text-gray-500 dark:text-gray-400 capitalize">{place.categoryName}</span>
            )}
          </div>
        </div>
        {place.rating !== undefined && place.rating > 0 && (
          <div className="flex items-center gap-1 flex-shrink-0">
            <Star size={14} className="fill-amber-400 text-amber-400" />
            <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
              {place.rating.toFixed(1)}
            </span>
            {place.reviewCount !== undefined && place.reviewCount > 0 && (
              <span className="text-xs text-gray-400 dark:text-gray-500">({place.reviewCount})</span>
            )}
          </div>
        )}
      </div>
      {place.address && (
        <div className="flex items-center gap-1 mt-1 text-xs text-gray-500 dark:text-gray-400">
          <MapPin size={12} />
          <span className="truncate">{place.address}</span>
        </div>
      )}
    </button>
  );
}
